"use client";

import { useEffect } from "react";
import { ensureOpenReplayTrackerStarted } from "@utils/openreplay";
import {
  installClickEventTracking,
  installViewTracking,
} from "@/src/lib/tracking/domBridge";
import {
  applyNativeTrackingAfterStart,
  subscribeNativeTrackingContext,
} from "@/src/lib/tracking/installNativeTracking";

export default function OpenReplayProvider() {
  useEffect(() => {
    // ⚠️ 订阅必须在 await 之前：原生收到 page-ready 就推 tracking-context，
    // 而 tracker 启动是异步的，等它就绪再订阅会丢掉早到的那条。
    const unsubscribe = subscribeNativeTrackingContext();

    let stopSessionReport = () => {};
    void ensureOpenReplayTrackerStarted().then(() => {
      // metadata 写入依赖 tracker 实例存在，所以这步必须等启动完成
      stopSessionReport = applyNativeTrackingAfterStart();
    });

    // 声明式契约（规范 §1）——不装的话新代码按文档写了没人读：
    // - 曝光 `data-or-view` + `data-or-param-*`
    // - 点击的业务事件 `data-or-event` + `data-or-param-*`（click 消息没有 payload 位，参数只能另发一条）
    const uninstallView = installViewTracking();
    const uninstallClick = installClickEventTracking();

    return () => {
      unsubscribe();
      stopSessionReport();
      uninstallView();
      uninstallClick();
    };
  }, []);

  return null;
}
